import { CurbyHeader } from '@/components/curby-header';

import { Box, Flex, Text, Title } from '@mantine/core';

import { BilbyChecklist } from '../bilby/checklist-bilby';
import { LawyerBilby } from '../bilby/lawyer-bilby';
import { PrivacyBilby } from '../bilby/privacy-bilby';
import { RenewBilby } from '../bilby/renew-bilby';
import { ScanBilby } from '../bilby/scan-bilby';
import { WinBilby } from '../bilby/win-bilby';
import styles from './styles.module.css';

export const BilbyHeader = ({
	title,
	subtitle,
	bilby,
	children,
}: {
	title: string;
	subtitle?: string;
	bilby: 'win' | 'checklist' | 'scan' | 'renew' | 'lawyer' | 'privacy';
	children?: React.ReactNode;
}) => {
	return (
		<>
			<CurbyHeader>
				<Flex direction="column" className={styles.entries}>
					<Title order={1}>{title}</Title>
					{subtitle && <Text className={styles.subtitle}>{subtitle}</Text>}
					{children}
				</Flex>
				<Box w={158} />
				{bilby === 'win' && <WinBilby className={styles.bilby} />}
				{bilby === 'checklist' && <BilbyChecklist className={styles.bilby} />}
				{bilby === 'scan' && <ScanBilby className={styles.bilby} />}
				{bilby === 'renew' && <RenewBilby className={styles.bilby} />}
				{bilby === 'lawyer' && <LawyerBilby className={styles.bilby} />}
				{bilby === 'privacy' && <PrivacyBilby className={styles.bilby} />}
			</CurbyHeader>
		</>
	);
};
